import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted. A Google Fonts CDN is both an availability dependency and a
// third-party request from an authenticated page, which government and
// enterprise deployments frequently forbid outright.
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource-variable/newsreader'

// Order matters: tokens define the variables, base consumes them, components
// build on both.
import './styles/tokens.css'
import './styles/base.css'
import './styles/components.css'

import { App } from './App'

const container = document.getElementById('root')
if (!container) throw new Error('#root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
